import JTF from '@beetronix/jtf'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import sharedTranslates from './shared-translates.js'
import routesTitles from './routes-titles.js'

Vue.use(VueI18n)
Vue.use(JTF)

const jtf = new JTF({
	locales: require.context('./locales'),
	sharedTranslates: [
		{ translates: sharedTranslates },
		{ translates: routesTitles, prefixKey: 'routes' }
	]
});

const i18n = new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || 'en',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
	messages: jtf.loadMessages()
})

export default i18n;

export function changeLang(lang) {
	i18n.locale = lang;
	document.documentElement.lang = lang;
	localStorage.setItem('lang', JSON.stringify(lang));
}

if ('lang' in localStorage) {
	changeLang(JSON.parse(localStorage.getItem('lang')));
} else {
	changeLang('en');
}